import api from './api';
import { API_ROUTES } from '@/lib/constants';
import type { Activity, PaginatedResponse, ApiResponse } from '@/types/table';

export const activityService = {
  getAll: async (params: Record<string, unknown>): Promise<PaginatedResponse<Activity>> => {
    const response = await api.get(API_ROUTES.ACTIVITIES, { params });
    return response.data;
  },

  getById: async (id: string): Promise<ApiResponse<Activity>> => {
    const response = await api.get(`${API_ROUTES.ACTIVITIES}/${id}`);
    return response.data;
  },

  create: async (data: Partial<Activity>): Promise<ApiResponse<Activity>> => {
    const response = await api.post(API_ROUTES.ACTIVITIES, data);
    return response.data;
  },
};
